import { render, staticRenderFns } from "./RegionalPlanning.vue?vue&type=template&id=09bf9254&"
import script from "./RegionalPlanning.vue?vue&type=script&lang=js&"
export * from "./RegionalPlanning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports